// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__1pemm","paramInput":"JobSimulator_paramInput__2OV5X","input":"JobSimulator_input__3onnC"};